import { Attr, HasMany, Model } from "spraypaint"

import ApplicationRecord from "./applicationRecord/applicationRecord"
import type { OrganizationalUnit } from "./organizationalUnit"
import type { Site } from "./site"

export const CIN_BELL_ID = "15"
export const HAWAIIAN_TELCOM_ID = "53"
export const WYNN_ID = "87"

// Hawaiian Telcom does not have its own Sigma workspace, so it uses
// altafiber's (org 15) custom workbooks.
export const ALTAFIBER_WORKSPACE_NAME = "altafiber"
export const demoOrganizations: string[] = ["City of Avalon"]

export interface IOrganizationCounts {
  billingGroups: number
  departments: number
  energyManagers: number
  meters: number
  organizationEmissions: number
  organizationalUnits: number
  sites: number
}

export type FeatureGroupName = "north_america_market" | "apac_market"

@Model()
export class Organization extends ApplicationRecord {
  public static readonly jsonapiType = "organizations"

  @HasMany("sites") public sites!: Site[]

  @HasMany("organizational_units")
  public organizationalUnits!: OrganizationalUnit[]

  @Attr() public locale: string | undefined

  @Attr() public readonly name!: string

  @Attr() public readonly demoOrganization!: boolean

  @Attr() public readonly dateCreated!: string

  @Attr() public readonly dateUpdated!: string

  @Attr() public readonly featureGroupNames!: FeatureGroupName[]

  @Attr() public localeId!: string

  @Attr() public readonly siteIds!: number[]

  @Attr() public readonly displayNullState!: boolean

  @Attr() public readonly hasBundled!: boolean

  @Attr() public readonly isMarketTest!: boolean

  @Attr() public readonly notes!: string

  @Attr() public readonly hierarchy!: string
}
